import Overlay from 'components/Layout/Overlay';
import {FC} from 'react';
import {FieldError} from 'react-hook-form';

import DateSelectContext from './context';
import DateSelectInput from './DateSelectInput';
import DateSelectPanel from './DateSelectPanel';
import useDateSelect from './hooks/useDateSelect';
import {defaultMinuteStep, MinuteStep} from './utils';

/**
 * https://date-fns.org/v1.28.5/docs/format
 * @default 'yyyy-MM-dd'
 */
export type BaseDateTimeSelectProps = {
    className?: string;
    disabled?: boolean;
    error?: FieldError;
    isCompact?: boolean;
    maxDate?: Date;
    minDate?: Date;
    minuteStep?: MinuteStep;
    name: string;
    placeholder?: string;
    required?: boolean;
    showTime?: boolean;
};

const BaseDateTimeSelect: FC<BaseDateTimeSelectProps> = (props) => {
    const {
        className,
        disabled,
        error,
        isCompact,
        maxDate,
        minDate,
        minuteStep = defaultMinuteStep,
        name,
        placeholder,
        required,
        showTime,
    } = props;

    const providerValue = useDateSelect({
        disabled,
        error,
        maxDate,
        minDate,
        minuteStep,
        name,
        required,
        showTime,
    });

    const {refInput, refPortal, show} = providerValue;

    return (
        <DateSelectContext.Provider value={providerValue}>
            <DateSelectInput
                className={className}
                isCompact={isCompact}
                placeholder={placeholder}
                ref={refInput}
            />
            {show && (
                <Overlay
                    aria-label="dropdown-overlay"
                    className="border border-blue-400 bg-dark-primary shadow-md"
                    element={refInput.current}
                    layoutLayer="z-dropdown"
                    layoutMethod="left-corner"
                    layoutOffset={8}
                    matchWidth={false}
                >
                    <DateSelectPanel ref={refPortal} />
                </Overlay>
            )}
        </DateSelectContext.Provider>
    );
};

export default BaseDateTimeSelect;
